// calendarConstants.js

export const HOUR_LABELS = Array.from({ length: 24 }, (_, hour) => {
  const period = hour >= 12 ? 'PM' : 'AM';
  const display = hour % 12 || 12;
  return `${display} ${period}`;
});
